import { Box } from '@chakra-ui/react';
import React, { useState } from 'react';
import { NudgeToast } from './NudgeToast';

export const ShowMoreNudges = ({ nudges, disclosureOnclose }) => {
  const [nudgeStates, setNudgeStates] = useState(() => {
    return nudges.map((nudge) => ({
      ...nudge,
      isToastOpen: true,
    }));
  });

  const allNudgesClosed = Object.values(nudgeStates).every(
    (item) => item?.isToastOpen === false
  );

  if (allNudgesClosed) {
    disclosureOnclose();
    return null;
  }

  const updateNudgeState = (id) => {
    setNudgeStates((prevNudgeStates) => {
      return prevNudgeStates.map((nudge) => {
        if (nudge.id === id) {
          return { ...nudge, isToastOpen: false };
        }
        return nudge;
      });
    });
  };

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100%"
      height="100%"
      backgroundColor="rgba(0, 0, 0, 0.5)"
      zIndex="999"
    >
      {nudgeStates.map(
        (nudge) =>
          nudge?.isToastOpen && (
            <NudgeToast
              key={nudge.id}
              config={nudge}
              onClose={() => updateNudgeState(nudge.id)}
            />
          )
      )}
    </Box>
  );
};
